const combine = require('mout/array/combine')
const difference = require('mout/array/difference')
const forOwn = require('mout/object/forOwn')

// function takes in the active node and the nodelist and outputs an object 

// activeNode: Object
// nodes: Object

export default function getNodesNotParentsOrChildren (activeNode, nodes) {
  let childrenIds = []
  let parentIds = []
  let output = {}

  // gather children ids into array
  if (activeNode.children) {
    forOwn(activeNode.children, (val, key, o) => {
      if (val) {
        childrenIds.push(key)
      }
    })
  }

  // gather parents ids into array
  if (activeNode.parents) {
    forOwn(activeNode.parents, (val, key, o) => {
      if (val) {
        parentIds.push(key)
      }
    })
  }

  // combine the array
  const usedNodeIds = combine(childrenIds, parentIds)

  // all node keys
  const nodeIds = Object.keys(nodes)

  // unused node ids
  const unusedNodeIds = difference(nodeIds, usedNodeIds)

  if (unusedNodeIds.length > 0) {
    unusedNodeIds.forEach((unusedNodeId) => {
      if (unusedNodeId !== activeNode.id) {
        output[unusedNodeId] = nodes[unusedNodeId] 
      }
    })
  } else {
    output = null
  }

  return output
}


// WEBPACK FOOTER //
// ./src/helpers/getNodesNotParentsOrChildren.js